export enum AuctionInquiryStatus {
  /** 대기 */
  PENDING = "PENDING",
  /** 검토중 */
  REVIEWING = "REVIEWING",
  /** 승인 */
  APPROVED = "APPROVED",
  /** 진행중 */
  IN_PROGRESS = "IN_PROGRESS",
  /** 완료 */
  COMPLETED = "COMPLETED",
  /** 취소 */
  CANCELLED = "CANCELLED",
}

export const AUCTION_INQUIRY_STATUS_LABEL: Record<AuctionInquiryStatus, string> = {
  [AuctionInquiryStatus.PENDING]: "대기",
  [AuctionInquiryStatus.REVIEWING]: "검토중",
  [AuctionInquiryStatus.APPROVED]: "승인",
  [AuctionInquiryStatus.IN_PROGRESS]: "진행중",
  [AuctionInquiryStatus.COMPLETED]: "완료",
  [AuctionInquiryStatus.CANCELLED]: "취소",
};

export const AUCTION_INQUIRY_STATUS_COLOR: Record<AuctionInquiryStatus, string> = {
  [AuctionInquiryStatus.PENDING]: "#9ca3af",
  [AuctionInquiryStatus.REVIEWING]: "#3b82f6",
  [AuctionInquiryStatus.APPROVED]: "#1e9b6b",
  [AuctionInquiryStatus.IN_PROGRESS]: "#f97316",
  [AuctionInquiryStatus.COMPLETED]: "#1e9b6b",
  [AuctionInquiryStatus.CANCELLED]: "#ef4444",
};

export type PaymentStatus = "PAID" | "APPROVAL_PENDING" | "APPLIED" | "PAYMENT_PENDING";

export const PAYMENT_LABEL: Record<PaymentStatus, string> = {
  PAID: "결제완료",
  APPROVAL_PENDING: "승인대기",
  APPLIED: "해당없음",
  PAYMENT_PENDING: "결제대기",
};

export const PAYMENT_COLOR: Record<PaymentStatus, string> = {
  PAID: "#1e9b6b",
  APPROVAL_PENDING: "#f59e0b",
  APPLIED: "#9ca3af",
  PAYMENT_PENDING: "#3b82f6",
};

export const SERVICE_CATEGORY_LABEL: Record<string, string> = {
  AUCTION_ALLCARE: "경매 올케어",
  NPL_ALLCARE: "NPL 올케어",
  BID_AGENT: "입찰 대행",
  RIGHTS_ANALYSIS: "권리 분석",
  AUCTION_CONSULTATION: "경매 상담",
};

export const INQUIRY_CATEGORY_LABEL: Record<string, string> = {
  AUCTION_ITEM_CONSULTATION: "경매 물건 상담",
  AUCTION_BID_REQUEST: "경매 입찰 요청",
  CONSULTING: "컨설팅",
  AUCTION_INVEST_CONSULTATION: "경매 투자 상담",
  OTHER_AUCTION_INQUIRY: "기타 경매 문의",
  NPL_INQUIRY: "NPL 문의",
  NPL_ITEM_REQUEST: "NPL 물건 요청",
  NPL_INVEST_CONSULTATION: "NPL 투자 상담",
  OTHER_NPL_INQUIRY: "기타 NPL 문의",
};
